import React, {PropTypes} from 'react';

const Code = React.createClass({
  propTypes: {
    children: PropTypes.node
  },
  getInitialState: function () {
    return {
      wrapper: "small"
    };
  },
  _onClick() {
    this.setState({
      wrapper: "full"
    });
  },
  render() {
    const { children } = this.props;
    const style = require('./Code.scss');
    return (
      <pre className={style[this.state.wrapper]} onClick={this._onClick}>
        {children}
      </pre>
    );
  }
});

export default Code;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Code/Code.js
 **/